/**
 * ga4.js — Google Analytics 4 초기화 (2026-09-02 신설 · 사장 지시)
 *
 * ★왜 외부 파일인가★ — 구글이 주는 스니펫은 인라인 `<script>` 인데, 이 저장소는
 * 인라인 스크립트를 ★감소 전용 래칫★ 으로 잠그고 있다(csp-progress-ratchet의
 * INLINE_SCRIPT_BASELINE). 인라인으로 붙이면 그 축이 +1 되어 red 다.
 * ⇒ 설정 코드를 여기로 빼고 레이아웃은 `<script src>` 두 줄만 싣는다.
 *
 * ★CSP★ — 지금 프로덕션 CSP 에는 script-src 가 없어서 동작한다(보안방 2026-08-31 5지시어).
 * ⚠️ 나중에 script-src 를 켤 때는 ★https://www.googletagmanager.com★ 을 허용 목록에
 * 넣어야 한다. 안 넣으면 이 파일이 아니라 ★gtag.js 로드가 조용히 차단★ 되고,
 * 화면은 멀쩡한데 수집만 멈춘다(가장 늦게 발견되는 실패 형태다).
 *
 * ★측정 ID 는 레이아웃이 data 속성으로 넘긴다★ — 이 파일에 상수를 박으면
 * 정본이 두 곳이 된다(seo.ts 의 GA4_MEASUREMENT_ID 가 정본).
 */
(function () {
  var el = document.currentScript
  var id = (el && el.getAttribute('data-ga-id')) || ''
  /* id 가 없으면 조용히 아무것도 하지 않는다 — 빈 config 로 잘못된 스트림을 만들지 않는다. */
  if (!id) return

  window.dataLayer = window.dataLayer || []
  function gtag() { window.dataLayer.push(arguments) }
  window.gtag = gtag
  gtag('js', /*t:DEVICE_NOW*/new Date()/*t*/)
  gtag('config', id)
})()
